<template>
  <div class="warp">
    <div class="search">
      时间：
      <el-date-picker type="datetime" v-model="startTime" size="small" :clearable="false" class="w-200" placeholder="选择开始时间"></el-date-picker>
      -
      <el-date-picker type="datetime" v-model="endTime" size="small" :clearable="false" class="w-200" placeholder="选择结束时间"></el-date-picker>
      <el-button class="m-l-10" type="primary" size="small" @click="getData">查询</el-button>
    </div>
    <div class="table-content">
      <nk-table :data="tableData" :columns="columns" :showPage="false">
      </nk-table>
    </div>
  </div>
</template>

<script>
import api from '@common/api/index.js'
import NkTable from '@/components/common/NkTable.vue'
import dateTool from '@/utils/dateTool.js'
export default {
  components: { NkTable },
  data () {
    return {
      tableData: [],
      startTime: new Date().setMonth(new Date().getMonth() - 1),
      endTime: new Date(),
      columns: [
        {
          prop: "time",
          label: "时间",
          show: true,
        },
        {
          prop: "before",
          label: "变更前余额",
          show: true,
        },
        {
          prop: "delta",
          label: "变更金额",
          show: true,
        },
        {
          prop: "after",
          label: "变更后余额",
          show: true,
        },
        {
          prop: "remark",
          label: "备注",
          show: true,
        }],
    }
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
      let startTime = dateTool.format(new Date(this.startTime), 'yyyy/MM/dd hh:mm:ss')
      let endTime = dateTool.format(new Date(this.endTime), 'yyyy/MM/dd hh:mm:ss')

      api.balance.getPersonalBalanceChangingLog(startTime, endTime).then(res => {
        if (res.data) {
          this.tableData = res.data
        }
        else {
          this.tableData = []
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.warp {
  width: 100%;
  height: 100%;
  padding: 0px 14px;
  box-sizing: border-box;
  color: #2e3842;
  text-align: left;
  display: flex;
  flex-flow: column;
  .search {
    flex: 0 0 40px;
  }
  .table-content {
    flex: 1;
    padding-bottom: 10px;
    box-sizing: border-box;
    overflow: hidden;
  }
}
.w-200 {
  width: 200px;
}
.m-l-10 {
  margin-left: 10px;
}
</style>